import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from '../reducers/nfc.reducer';

const getState = createFeatureSelector<fromReducer.NFCState>(
    fromReducer.featureKey
);

const getPageState = createSelector(getState, (state) => state);

export const getIsLoading = createSelector(getPageState, fromReducer.isLoading);
export const getSucceeded = createSelector(getPageState, fromReducer.succeeded);
export const getHasError = createSelector(getPageState, fromReducer.hasError);
export const getErrorMessage = createSelector(getPageState, fromReducer.errorMessage);
export const getNFCDevices = createSelector(getPageState, fromReducer.nfcDevices);

